import { intersection, noop } from 'lodash';
import allProviders, { BaseProvider } from './providers';

const symbols = {
  provider: Symbol('Provider instance property'),
  events: Symbol('Events instance property'),
  options: Symbol('Options property'),
};

const defaultOptions = {
  provider: null,
  adminRoles: ['manager'],
  onLogin: noop,
  onLogout: noop,
};

export default class Auth {
  constructor(events) {
    this[symbols.events] = events;
  }

  /**
   * All available providers
   */
  providers = allProviders;

  async init(options) {
    this[symbols.options] = {
      ...defaultOptions,
      ...options,
    };

    const { provider, onLogin, onLogout } = this[symbols.options];
    const events = this[symbols.events];

    if (!(provider instanceof BaseProvider)) {
      throw new Error('SDK.Auth provider was not set or invalid');
    }

    this[symbols.provider] = provider;

    await provider.init({
      onLogin: async () => {
        await onLogin();
        events.emit(events.types.onLogin);
      },
      onLogout: async () => {
        await onLogout();
        events.emit(events.types.onLogout);
      },
    });

    return this;
  }

  async login(...args) {
    return this[symbols.provider].login(...args);
  }

  async logout(...args) {
    return this[symbols.provider].logout(...args);
  }

  async emitLogout() {
    const events = this[symbols.events];
    events.emit(events.types.onLogout);
  }

  async renew(...args) {
    return this[symbols.provider].renew(...args);
  }

  async clear(...args) {
    return this[symbols.provider].clear(...args);
  }

  getIdentity() {
    const { adminRoles } = this[symbols.options];
    const identity = this[symbols.provider].getIdentity();

    if (!identity) {
      return null;
    }

    const isAdmin = identity.isAdmin || !!intersection(adminRoles, identity.roles).length;

    return {
      ...identity,
      isAdmin,
    };
  }

  getAccessObject() {
    return this[symbols.provider].getAccessObject();
  }

  getRequestHeaders() {
    return this[symbols.provider].getRequestHeaders();
  }
}



// WEBPACK FOOTER //
// ./src/Auth/Auth.js